import { useGLTF } from '@react-three/drei';
import InstanceModels from 'templateFor3D/InstanceModels';
import dataList from 'assets/data/pineTreeForPart1.json';

export default function TreeInstance() {
  const { nodes, materials } = useGLTF('trees/tree.glb');
  return (
    <InstanceModels
      geometry={nodes.Plane037_Tree_tex_0.geometry}
      material={materials.Tree_tex}
      dataList={dataList}
      pos={[0, 0, 0]}
    />
  );
}
